<template>
  <div class="box">
    <div class="head">
      <Header></Header>
    </div>
    <!-- 行业新闻 -->
    <div class="div">
      <div class="across"></div>
      <div class="tabs">
        <div class="crumbs">
          <span>
            <!-- <router-link :to="{ path: '/' }"> -->
            <img src="../../assets/images/header/white.png" alt="logo" />
            首页
            <!-- </router-link> -->
          </span>
          &gt;
          <!-- <span @click="activeName = 'one'" style="cursor: pointer"
            >行业新闻</span
          >
          &gt; -->
          <span>{{ text }}</span>
        </div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="行业新闻" name="one">
            <ul>
              <li
                :class="active == index ? 'information1' : 'information2'"
                v-for="(item, index) in tableData"
                :key="index"
                @mouseover="mouse(index)"
                @click="clickBtn(index)"
              >
                <div class="left">
                  <img :src="item.src" alt="..." />
                </div>
                <div class="right">
                  <div class="title">
                    {{ item.title }}
                  </div>
                  <div class="time">发布时间：{{ item.time }} 浏览次数:144</div>
                  <div class="text">
                    {{ item.text }}
                  </div>
                </div>
              </li>
            </ul>
          </el-tab-pane>
          <!-- <el-tab-pane label="视频教学" name="two">
            <div class="videoTeaching" v-if="show">
              <div
                class="videos"
                v-for="(item, index) in videos"
                :key="index"
                @click="videoBtn(index)"
              >
                <div class="pic">
                  <img :src="item.src" alt="" />
                </div>
                <div class="text">
                  <div class="title">{{ item.title }}</div>
                  <div class="data">{{ item.text }}</div>
                </div>
              </div>
            </div>
            <div class="paging">
              <el-pagination
                background
                layout="prev, pager, next"
                :total="total"
                :page-size="pageSize"
              >
              </el-pagination>
            </div>
          </el-tab-pane> -->
        </el-tabs>
      </div>
    </div>
    <div class="foot">
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Header from "@/views/header/Header.vue";
import Footer from "@/views/footer/Footer.vue";
export default {
  components: { Header, Footer },
  data() {
    return {
      activeName: "one",
      text: "行业新闻",
      active: 0,
      tableData: [
        {
          src: require("../../assets/images/dynamicInformation/20220420144212.png"),
          title: "环保企业如何在疫情常态化下找到发展机遇与动能？",
          time: "2022-04-20",
          text: "现阶段全国共有近5万多家的环环保企业，其中90%以上是中小微型企业，由于缺乏有序的竞争环境，行业发展难以得到持续创新技术的支持，整体技术含量不高的主营业务严重制约了环保行业的投资价值。此次疫情加快了行业并购重组进程。围绕核心企业的产业链收购、兼并产业链相关企业，通过协同投资机构的培育与孵化后再逐步倒入核心企业，可提升核心企业的竞争力，进而提升环保行业的整体水平。新冠肺炎疫情势必对经济产生一定影响，生态环保企业的投资环境、项目储备、技术研发、资金支撑都会面临新的挑 战。在项目推进上，要一手抓防疫，一手抓施工组织，还要考虑上下游供应和链接，成本增加，难度增加。许多生态环 保类的企业也开始思考转型，纯施工类企业想转向投资类；投资施工类的想转向投资施工技术类；投资施工技术类想转 向细分行业全产业链；全产业链企业还想转向一、 二、三产业联动。生态环保企业的每一次转型都是凤凰涅槃，他们的 总体研发投入在1%—2.5%之间。低于高新技术企业3%的水平。没有核心技术的转型终究会归于沉寂。",
        },
        {
          src: require("../../assets/images/dynamicInformation/20220420144547.png"),
          title: "如何精准精监控、降低环保处罚风险？园区环保信息化平台如何建？",
          time: "2022-04-20",
          text: "环保督查常态化，工业园区企业多、专业人员少，使得园区环保管理压力越来越大，如何高效管理，从容应对督查检查，是园区面临的难题，这时您需要一款专业的环保软件和服务团队。中泽宇华环保管理系统紧抓环保管理要点，有效提高环保管理人员工作的效率；同时也能帮助第三方企业进行标准化、规范化的环保服务，提升服务质量。管理端能直接查看各企业（各车间）污染源分布、数量统计、污染种类、排放量等统计数据，同时可以直接链接查看数据详情。各部门负责人可以快速了解本企业环保情况，污染物种类、排放量、实时监测数据、上级通知、报警提示等。检查有针对性，自查有目标。废水监测系统包括：排口信息、排口自行监测、排口在线监测、管网可视化、预警预报等5大 模块，在“一张图”总体框架下，利用GIS技术建立企业雨污管网图，包含管网长度、管径、埋地 深度、检修井、采样点、在线监测等数字信息，内置预警报警数据分析模型，对企业异常排放、 超标排放、雨污混流等进行监管，及时发现问题，及时处理。",
        },
        {
          src: require("../../assets/images/dynamicInformation/20220420145141.png"),
          title: "“环保管家”如何帮政府和企业降低被问责和处罚风险？",
          time: "2022-04-18",
          text: "环保管理是一项复杂工作，随着环保管控不断升级，要求越来越高，“专业人做专业事”的理念不断深入，越来越多的环境管理部门和排污企业 聘请“环保管家”进行管理。做好一家公司的“环保管家”工作容易，做好几十家几百家甚至上千家企业的“环保管家”工作则十分不容易。传统的服务方式，需要投入巨大的人力、时间进行现场检查工作，早期一个县/园区的环保管家服务费用高达数百万，但随着市场竞争越来越激烈，现在的环保管家服务价格持续走低，出现某市1000多家的环保管家政府采购费用不足50万，服务质量大大降低。“环保管家”的效果微乎其微，多数以走过场结束。北京中泽宇华环境科技有限公司根据自身多年从事环保管理的经验，研发智慧环保综合管控系统， 能快速高效地帮助环保管理部门和排污企业提高环保管理水平，减少环保局被约谈问责、排污企业被环境处罚的风险。",
        },
        {
          src: require("../../assets/images/dynamicInformation/20220420161432.png"),
          title: "生态部：关于印发《关于加强排污许可执法监管的指导意见》的通知",
          time: "2022-04-12",
          text: "关于加强排污许可执法监管的指导意见为贯彻落实党中央、国务院关于深入打好污染防治攻坚战有关决策部署，全面推进排污许可制度改革，加快构建以排污许可制为核心的固定污染源执法监管体系，持续改善生态环境质量，提出以下意见。以习近平新时代中国特色社会主义思想为指导，全面贯彻党的十九大和十九届历次全会精神，深入贯彻习近平生态 文明思想，按照党中央、国务院决策部署，坚持精准治污、科学治污、依法治污，以固定污染源排污许可制为核心， 创新执法理念，加大执法力度，优化执法方式，提高执法效能，构建企业持证排污、政府依法监管、社会共同监督 的生态环境执法监管新格局，为深入打好污染防治攻坚战提供坚强保障。到2023年年底，重点行业实施排污许可清单式执法检查，排污许可日常管理、环境监测、执法监管有效联动，以排污 许可制为核心的固定污染源执法监管体系基本形成。到2025年年底，排污许可清单式执法检查全覆盖，排污许可执法监 管系统化、科学化、法治化、精细化、信息化水平显著提升，以排污许可制为核心的固定污染源执法监管体系全面建立。",
        },
      ],
      videos: [
        {
          src: require("../../assets/images/dynamicInformation/video/img001.png"),
          title: "都说企业停产、人宅家，那污染从哪里来？",
          text: "不上班还有雾霾，到底是为啥？节前很多农村也不准放鞭炮，过了三十开始人也不走动了，车也不开了，工厂都放假了，但空气依旧浑浊。",
        },
        {
          src: require("../../assets/images/dynamicInformation/video/img002.png"),
          title: "中国大气污染治理历程",
          text: "数据由各级生态环境部门发布的实时空气质量统计而成，其中2020年数据截止12月27日。",
        },
        {
          src: require("../../assets/images/dynamicInformation/video/img004.png"),
          title: "泄漏检测与修复(LDAR)的现状和发展",
          text: "从2013年中国陆续开展LDAR项目以来,对设备的泄漏的综合管理起到了积极作用。截止2016年低,重点行业的首轮LDAR工作基本完成。首轮LDAR工作的VOCs减排率在30-50%,部分企业甚至达到70%。有效减少了VOCs的排放。",
        },
        {
          src: require("../../assets/images/dynamicInformation/video/img005.png"),
          title: "“环保管家”工作内容如何从“虚”向“实”",
          text: "“环保管家”,即环境管理服务,是指环保服务企业为政府或企业提供综合环保一站式托管服务,统筹解决企业或政府面临的环境问题;提高决策科学性,有效降低企业环保管理成本;提升企业环境面貌,解决企业因环保而带来的烦恼。 ",
        },
        {
          src: require("../../assets/images/dynamicInformation/video/img006.png"),
          title: "石化企业VOCs要点解读",
          text: "2017-2018年采暖季期间(11月15日-次年3月15日),京津翼及周边地区大气污染传输通道城市(“2+26”城市) PM2.5的平均浓度为85微克/立方米,其中有机物、硝酸盐、硫酸盐、按盐等主要组分的占比分别为28%,19%,12%和11%,揭示京津翼大气PM2.5化学特征发生了显著变化,2018年11月-2019年2月主要站点在线测量的结果再次印证了这一变化规律。",
        },
        // {
        //   src: require("../../assets/images/dynamicInformation/video/img003.png"),
        //   title: "环保讲坛，以智能管理助力环保行业",
        //   text: "以工匠精神带动品质革命，以智能管理助力环保行业，创新永无止境。",
        // },
        // {
        //   src: require("../../assets/images/dynamicInformation/video/img007.png"),
        //   title: "“一企(厂)一策”开展方法和实例分析",
        //   text: "中华环保联合会VOCs污染防治专业委员会,是中华环保联合会在VOCs污染防治领域成立的专业分支机构,是中华环保联合会在大气污染防治领域职能的延伸和支撑。由从事VOCs污染防治技术与产业研究、开发、服务、工程、投资的企业、事业单位,社团组织和相关单位为实现共同意愿而自愿组成的。 ",
        // },
      ],
      show: true,
      pageSize: 9,
      total: 0,
    };
  },

  created() {
    this.$store.state.menu = 4;
  },

  mounted() {},

  methods: {
    // mouseOver($event) {
    //   $event.currentTarget.className = "information1";
    // },
    // mouseLeave($event) {
    //   $event.currentTarget.className = "information2";
    // },
    mouse(e) {
      this.active = e;
    },
    handleClick() {
      this.active = 0;
    },
    clickBtn(e) {
      switch (e) {
        case 0:
          window.open(
            // "https://mp.weixin.qq.com/s/l4DYrsJ4YAKPY2gWLpPdgg",
            this.$router.resolve({ path: "/informationOne" }).href,
            "_blank"
          );
          break;
        case 1:
          window.open(
            // "https://mp.weixin.qq.com/s/wHjRbXeMAL50QBSacfEpfw",
            this.$router.resolve({ path: "/informationTwo" }).href,
            "_blank"
          );
          break;
        case 2:
          window.open(
            // "https://mp.weixin.qq.com/s/KJWm3A4LLqM8uCqkxw5S8A",
            this.$router.resolve({ path: "/informationThree" }).href,
            "_blank"
          );
          break;
        case 3:
          window.open(
            // "https://mp.weixin.qq.com/s/mF-PIbf4uUudhKjoUtX4hg",
            this.$router.resolve({ path: "/informationFour" }).href,
            "_blank"
          );
          break;
      }
      // let detailUrl = this.$router.resolve({
      //   path: "/informationOne",
      //   query: { id: e },
      // });
      // window.open(detailUrl.href, "_blank");
    },
    videoBtn(e) {
      // console.log("视频点击事件",e);
      let detailUrl = this.$router.resolve({
        path: "/videoPage",
        query: { id: e },
      });
      window.open(detailUrl.href, "_blank");
    },
  },
  watch: {
    activeName(news) {
      switch (news) {
        case "one":
          this.text = "行业新闻";
          break;
        // case "two":
        //   this.text = "视频教学";
        //   break;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.box {
  .head {
    position: fixed;
    width: 100%;
    height: 100px;
    background-color: #fff;
    z-index: 5;
    color: #333;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
  }
  .div {
    width: 100%;
    padding-top: 100px;
    .across {
      width: 100%;
      height: 50px;
      background-color: #0064a1;
    }
    .tabs {
      position: relative;
      padding: 0 50px;
      max-width: 1200px;
      min-width: 900px;
      margin: auto;
      margin-top: -45px;
      .information1 {
        display: flex;
        width: 100%;
        margin: 50px 0;
        cursor: pointer;
        padding-bottom: 20px;
        border-bottom: 1px solid #d9dadc;
        animation: rotation 0.7s linear;
        .left {
          min-width: 350px;
          img {
            width: 100%;
          }
        }
        .right {
          padding-left: 30px;
          .title {
            font-size: 20px;
            font-weight: bold;
            // text-indent: 30px;
            color: #008cd7;
          }
          .time {
            font-size: 12px;
            color: #999;
            line-height: 30px;
            text-indent: 30px;
          }
          .text {
            font-size: 16px;
            line-height: 1.5;
            text-indent: 30px;
            color: #666;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 7;
            -webkit-box-orient: vertical;
            text-align: justify;
          }
        }
      }
      .information2 {
        display: flex;
        width: 100%;
        height: 150px;
        margin: 70px 0;
        border-bottom: 1px solid #d9dadc;
        .left {
          width: 200px;
          min-width: 200px;
          img {
            width: 100%;
          }
        }
        .right {
          padding-left: 20px;
          .title {
            font-size: 20px;
            font-weight: bold;
            // text-indent: 30px;
            padding-bottom: 10px;
            color: #333;
          }
          .time {
            display: none;
          }
          .text {
            font-size: 12px;
            line-height: 1.5;
            text-indent: 30px;
            color: #666;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-align: justify;
          }
        }
      }
      @-webkit-keyframes rotation {
        from {
          transform: scale(0.8, 0.8);
        }
        50% {
          transform: scale(1.05, 1.05);
        }
        to {
          transform: scale(1, 1);
        }
      }

      .videoTeaching {
        // display: flex;
        // flex-wrap: wrap;
        // justify-content: space-between;
        margin-top: 100px;
        margin-bottom: 50px;
        width: 100%;
        height: 100%;
        .videos {
          float: left;
          width: 33.33%;
          // width: 28%;
          height: 260px;
          margin-bottom: 50px;
          cursor: pointer;
          transition: 0.3s;
          -moz-transition: 0.3s; /* Firefox 4 */
          -webkit-transition: 0.3s; /* Safari 和 Chrome */
          -o-transition: 0.3s; /* Opera */
          .pic {
            width: 90%;
            margin: auto;
            img {
              width: 100%;
            }
          }
          .text {
            width: 80%;
            height: 14%;
            line-height: 1.5;
            color: #333;
            padding: 10px 0px;
            margin: auto;
            .title {
              font-size: 16px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              line-height: 1.5;
              color: #333333;
              padding-bottom: 5px;
              overflow: hidden;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
            }
            .data {
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              line-height: 1.5;
              color: #666666;
              overflow: hidden;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }
          }
        }
        .videos:hover {
          // box-sizing: border-box;
          box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.2);
          margin-top: -2px;
          transition: 0.3s;
          -moz-transition: 0.3s; /* Firefox 4 */
          -webkit-transition: 0.3s; /* Safari 和 Chrome */
          -o-transition: 0.3s; /* Opera */
          padding-bottom: 2px;
        }
      }
    }
  }
  .crumbs {
    position: absolute;
    right: 50px;
    line-height: 40px;
    z-index: 2;
    color: #fff;
    font-size: 16px;
  }
  .router-link-active {
    text-decoration: none;
    color: #fff;
  }
  // tabs标题的字号
  /deep/ .el-tabs__item {
    font-size: 16px;
  }
}
</style>
